import React from 'react';
import AmalgamWaste from '../../../views/corp/wastemanagement/amalgamwaste/AmalgamWaste';
import MedicalWaste from '../../../views/corp/wastemanagement/medicalwaste/MedicalWaste';
import PharmaceuticalWaste from '../../../views/corp/wastemanagement/pharmaceuticalwaste/PharmaceuticalWaste';

const wasteManagementRoutes = [
  {
    path: '/corp/amalgam-waste',
    element: <AmalgamWaste />
  },
  {
    path: '/corp/medical-waste',
    element: <MedicalWaste />
  },
  {
    path: '/corp/pharmaceutical-waste',
    element: <PharmaceuticalWaste />
  }
];

export default wasteManagementRoutes;
